<div mat-dialog-content>
	<pre>{{json}}</pre>
</div>
<div mat-dialog-actions>
	<button mat-button [mat-dialog-close]="null">Close</button>
</div>
